









import { defineComponent, SetupContext } from '@vue/composition-api'
import { UseVuexComposition } from '@/composition/UseVuexComposition'

// ================================
// Component
// ================================
export default defineComponent({
  name: 'Inbox',
  setup (props, context: SetupContext) {
    const vuex = UseVuexComposition(context)
    return {
      vuex
    }
  }
})
